import { render } from "./ProdImg02.vue?vue&type=template&id=308d5a50&scoped=true"
import script from "./ProdImg02.vue?vue&type=script&lang=js"
export * from "./ProdImg02.vue?vue&type=script&lang=js"

import "./ProdImg02.vue?vue&type=style&index=0&id=308d5a50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308d5a50"]])

export default __exports__